import { render, staticRenderFns } from "./groups-top-bar-group.vue?vue&type=template&id=2c3ce634&"
import script from "./groups-top-bar-group.vue?vue&type=script&lang=js&"
export * from "./groups-top-bar-group.vue?vue&type=script&lang=js&"
import style0 from "./groups-top-bar-group.vue?vue&type=style&index=0&id=2c3ce634&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports